/* SORA — Lenis smooth scroll, site-wide.
 *
 * Why this is safe with the journey rig: Lenis (window mode) animates the REAL
 * window scroll each frame, so native `scroll` events keep firing and
 * getBoundingClientRect stays truthful — the scroll-scrubbed sections read the
 * same values they always did, just fed at a smoothed rate.
 *
 * Guard rails:
 * - prefers-reduced-motion → never boots (native scroll, T3 tier intact).
 * - syncTouch stays OFF → phones keep 100% native touch scrolling (the old
 *   mobile-glitch minefield stays closed); Lenis only smooths wheel input.
 * - Anchor clicks route through lenis.scrollTo so in-page links glide instead
 *   of jumping (falls back to native when a target is missing).
 */
(function () {
  'use strict';

  function init() {
    if (window.__soraLenis) return;
    if (typeof Lenis === 'undefined') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var lenis = new Lenis({
      autoRaf: true, // Lenis drives its own rAF loop — sturdier than a hand-rolled chain
      duration: 1.1,
      // luxury ease-out — same family as the theme's --esnc-ease-luxury
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true,
      syncTouch: false,
      touchMultiplier: 1,
      // Let overlays with their own scroll (the Botpress webchat panel) scroll
      // natively — otherwise Lenis captures the wheel and scrolls the page instead
      // of the chat's message list. Evaluated per-event, so it works no matter when
      // Botpress mounts. See also the data-lenis-prevent tagging below.
      prevent: function (node) {
        return !!(node && node.closest && node.closest('.bpChatContainer, .bpFab, [data-lenis-prevent]'));
      }
    });
    window.__soraLenis = lenis;

    // Belt-and-suspenders: tag the Botpress containers with data-lenis-prevent as
    // soon as they mount (also gives them overscroll-behavior:contain via theme CSS).
    var tagBotpress = function () {
      var els = document.querySelectorAll('.bpChatContainer, .bpFab');
      for (var i = 0; i < els.length; i++) {
        if (!els[i].hasAttribute('data-lenis-prevent')) els[i].setAttribute('data-lenis-prevent', '');
      }
    };
    tagBotpress();
    if (window.MutationObserver) {
      new MutationObserver(tagBotpress).observe(document.body, { childList: true, subtree: true });
    }

    // In-page anchors glide (journey chapter dots, "skip to shop", footer links)
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a) return;
      var hash = a.getAttribute('href');
      if (!hash || hash.length < 2) return;
      var target;
      try { target = document.querySelector(hash); } catch (_) { return; }
      if (!target) return;
      e.preventDefault();
      lenis.scrollTo(target, { duration: 1.2 });
      if (window.history && window.history.pushState) window.history.pushState(null, '', hash);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
